import React from "react"
import CMediaVideo from "../elements/c_media_video"
import DfbHeadline from "../ui-kit/dfb_headline";
import Section from "./section"

const MMediaVideo = (props) => {
  return (
    <Section
      baseClass="m-Media"
      defaultPaddingTop="extra-small"
      data={props.data}
    >
      <div className="m-Media-wrapper">
        <div className="m-Media-container">
          {props.data.headline &&
            <DfbHeadline headline={props.data.headline} headline_level="h3" add_class="m-Media-headline" />
          }
          <div className="m-Media-content">
            <figure className="m-Media-figure">
              <CMediaVideo
                video_embed_id={props.data.video_embed_id}
                video_autoplay={props.data.video_autoplay}
              />
              {props.data.text &&
                <figcaption className="m-Media-figcaption">
                  {props.data.text}
                </figcaption>
              }
            </figure>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MMediaVideo
